import { gameIdSchema, upgradeIdSchema } from '@argus-labs/auth-shared/auth'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { signInWithToken, takeUrlToken } from '@/lib/url-token'
import { generateTitle } from '@/lib/utils'

export const Route = createFileRoute('/upgrade-guest')({
  validateSearch: z.object({ upgradeId: upgradeIdSchema, gameId: gameIdSchema }),
  head: () => ({ meta: [{ title: generateTitle('Save Your Progress') }] }),
  beforeLoad: async ({ search, location }) => {
    const token = takeUrlToken(location)
    if (!token || !(await signInWithToken(token))) throw redirect({ to: '/upgrade-failed' })

    throw redirect({
      to: '/register',
      search: { upgradeId: search.upgradeId, gameId: search.gameId },
      replace: true,
    })
  },
})
